"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceBucketKeysWithUrls;

var _lodash = _interopRequireDefault(require("lodash.flattendeep"));

var _tempAuthTokenHandler = _interopRequireDefault(require("@devsta/temp-auth-token-handler"));

var _getSignedUrls = _interopRequireWildcard(require("./queries/getSignedUrls"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** @module replaceBucketKeysWithUrls */


var JOIN_CONST = '.';
/* Retrieving URLs from the network */

function getS3Urls(_x) {
  return _getS3Urls.apply(this, arguments);
}
/* Building data object hierarchy */


function _getS3Urls() {
  _getS3Urls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apiClient, urlsConfig, organisationId, _ref3, getS3SignedUrls, _ref4, data, errors;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiClient = _ref.apiClient, urlsConfig = _ref.urlsConfig, organisationId = _ref.organisationId;

            if (!apiClient.request) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return apiClient.request(_getSignedUrls.getSignedUrlsQuery, {
              urlsConfig: urlsConfig,
              organisationId: organisationId
            });

          case 4:
            _ref3 = _context.sent;
            getS3SignedUrls = _ref3.getS3SignedUrls;
            return _context.abrupt("return", getS3SignedUrls);

          case 7:
            _context.next = 9;
            return apiClient.query({
              variables: {
                urlsConfig: urlsConfig,
                organisationId: organisationId
              },
              query: _getSignedUrls.default,
              context: {
                module: 'assets'
              },
              fetchPolicy: 'no-cache'
            });

          case 9:
            _ref4 = _context.sent;
            data = _ref4.data;
            errors = _ref4.errors;

            if (!(errors && errors.length)) {
              _context.next = 14;
              break;
            }

            throw new Error(errors[0].message);

          case 14:
            return _context.abrupt("return", data.getS3SignedUrls);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getS3Urls.apply(this, arguments);
}

function joinPaths(firstPath, secondPath) {
  if (!firstPath || !secondPath) {
    return firstPath || secondPath;
  }

  return "".concat(firstPath).concat(JOIN_CONST).concat(secondPath);
}

function dataIsIgnored(data, ignorePattern) {
  return ignorePattern && new RegExp(ignorePattern).test(data);
}

function getPathsFromData(data, substitutedKeys, ignorePattern, parentPath) {
  var paths = substitutedKeys.reduce(function (validPaths, substitutedKey) {
    if (typeof substitutedKey === 'string') {
      return data && data[substitutedKey] && !dataIsIgnored(data[substitutedKey], ignorePattern) ? [].concat(_toConsumableArray(validPaths), [joinPaths(parentPath, substitutedKey)]) : validPaths;
    }

    if (!data) {
      return validPaths;
    }

    var nestedKey = getPathsFromData(data[substitutedKey.key], substitutedKey.subKeys, ignorePattern, joinPaths(parentPath, substitutedKey.key));

    if (!nestedKey.length) {
      return validPaths;
    }

    return [].concat(_toConsumableArray(validPaths), [nestedKey]);
  }, []).filter(Boolean);
  return (0, _lodash.default)(paths);
}
/* Build data object hierarchy */


function getValueFromDataWithPathKeys(data, keysArray) {
  if (keysArray.length === 1) {
    return {
      bucketKey: data[keysArray[0]],
      action: 'get'
    };
  }

  return getValueFromDataWithPathKeys(data[keysArray[0]], keysArray.slice(1, keysArray.length));
}
/* Pulling out S3 bucket keys using the data object hierarchy */


function getS3KeyFromPath(path, data) {
  var keys = path.split(JOIN_CONST);
  return getValueFromDataWithPathKeys(data, keys);
}

function getS3KeysFromPathStructure(data, paths) {
  return paths.map(function (path) {
    return getS3KeyFromPath(path, data);
  });
}
/* Adding the new URLs into the original data object */


function updateDataSubsetWithS3Url(data, path, url) {
  var keys = path.split(JOIN_CONST);
  var lastKey = keys[keys.length - 1];
  var bottomNestedObject = keys.reduce(function (currentNestedObject, key) {
    return key === lastKey ? currentNestedObject : currentNestedObject[key];
  }, data);
  bottomNestedObject[lastKey] = url;
  return data;
}

function populateDataWithS3Urls(data, paths, urls) {
  return paths.reduce(function (newData, path, index) {
    return updateDataSubsetWithS3Url(newData, path, urls[index]);
  }, // We use this to deep clone the object so we can change nested values
  JSON.parse(JSON.stringify(data)));
}
/**
 * Takes a data object and swaps out any defined key/bucketKey values with pre-signed urls.
 * Supports nested objects/keys.
 *
 * eg. { foo: '/foo/foobar.jpg' }, ['foo'] => { foo: 'aws.com/.../foo/foobar.jpg' }
 *
 * eg. { foo: { bar: '/foo/foobar.jpg' } }, [{ key: 'foo', subKeys: ['bar'] }] =>
 *        { foo: { bar: 'aws.com/.../foo/foobar.jpg' } }
 *
 * @param {*} apiClient
 * @param {Object} data
 * @param {Array<SubstitutedKey>} substitutedKeys
 * @param {string} organisationId
 * @param {string} tempAuthToken
 * @return {Promise<*>}
 */


function replaceBucketKeysWithUrls(_x2) {
  return _replaceBucketKeysWithUrls.apply(this, arguments);
}

function _replaceBucketKeysWithUrls() {
  _replaceBucketKeysWithUrls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var apiClient, data, substitutedKeys, organisationId, ignorePattern, tempAuthToken, selectedOrganisationId, dataHierarchyStructure, urlsConfig, tempAuthTokenHandler, urls;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            apiClient = _ref2.apiClient, data = _ref2.data, substitutedKeys = _ref2.substitutedKeys, organisationId = _ref2.organisationId, ignorePattern = _ref2.ignorePattern, tempAuthToken = _ref2.tempAuthToken;

            if (apiClient) {
              _context2.next = 3;
              break;
            }

            throw new Error('Must provide an apollo API client');

          case 3:
            selectedOrganisationId = organisationId || data.organisationId;
            dataHierarchyStructure = getPathsFromData(data, substitutedKeys, ignorePattern);
            urlsConfig = getS3KeysFromPathStructure(data, dataHierarchyStructure);

            if (urlsConfig.length) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", data);

          case 8:
            tempAuthTokenHandler = new _tempAuthTokenHandler.default();
            tempAuthTokenHandler.attemptToOverrideToken(tempAuthToken);
            _context2.next = 12;
            return getS3Urls({
              apiClient: apiClient,
              urlsConfig: urlsConfig,
              organisationId: selectedOrganisationId
            });

          case 12:
            urls = _context2.sent;
            tempAuthTokenHandler.attemptToResetToken();
            return _context2.abrupt("return", populateDataWithS3Urls(data, dataHierarchyStructure, urls));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _replaceBucketKeysWithUrls.apply(this, arguments);
}